import { CHART_BRIEFING_FOLLOW_UP_ACTIONS } from '../lib/chartBriefingFollowUpActions';

export function ChartBriefingFollowUpChips({ onSelect }: { onSelect: (command: string) => void }) {
  return (
    <div
      className="mt-4 flex flex-wrap gap-2"
      data-testid="chart-briefing-follow-up-chips"
      aria-label="Chart review shortcuts"
    >
      {CHART_BRIEFING_FOLLOW_UP_ACTIONS.map((a) => (
        <button
          key={a.command}
          type="button"
          onClick={() => onSelect(a.command)}
          className="rounded-full border border-border bg-background px-3 py-1.5 text-[12px] font-medium text-foreground transition-colors hover:bg-surface-hover sm:text-[13px]"
        >
          {a.label}
        </button>
      ))}
    </div>
  );
}
